<template>
	<div>
		<div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('wholesale.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
					{
						text: $t('wholesale.pageTitle'),
						href: '/admin/whole-sales'
					},
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
		<ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
            <div class="row">
              <div class="col-md-9">
                <ProductList v-model="model" @calculate="onCalculate" />
                <ItemDetail v-model="model" :validate="errors" class="ts-mt-3" ref="itemDetail" />
              </div>
              <div class="col-md-3 ts-space-y-4">
                <CustomerSaleDate v-model="model" :validate="errors" />
                <Reference 
                  v-model="model" 
                  :validate="errors"
                  @loading="(value) => loading = value"
                />
                <ExchangeRate v-model="model" :validate="errors" />
                <Payment v-model="model" :validate="errors" />
                <PaymentMethod 
                  v-model="model" 
                  :validate="errors"
                  @loading="(value) => loading = value" 
                />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
                <ts-button
                  @click.prevent="$router.push({ name: 'wholesale'})"
                >{{$t('back')}}</ts-button>
               
                <!-- <ts-button
                  :waiting="waiting" 
                  @click.prevent="onUpdate"  
                  color="primary">{{$t('update')}}</ts-button> -->
              </div>
            </div>
        </ts-loading-banner>
      </ts-card-wrapper>
		</ts-card>
	</div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import ItemDetail from './components/item-detail'
// import Reference from './components/reference'
import CustomerSaleDate from './components/customer-sale-date.vue'
import Reference from './components/references.vue'
import ExchangeRate from './components/exchange-rate.vue'
import Payment from './components/payment.vue'
import PaymentMethod from './components/payment-method.vue'
import ProductList from './components/product-list.vue'

export default {
	name: 'wholesaleEdit',
  components: {
    ItemDetail,
    Reference,
    CustomerSaleDate,
    ExchangeRate,
    Payment,
    PaymentMethod,
    ProductList
  },
	data(){
		return {
			waiting: false,
			loading: false,
			errors: new Errors(),
			model: {
				stock_out_id: null,
        stock_out_date: moment().format('DD-MM-YYYY'),
        customer_id: '',
        sub_total: '',
        discount: 0,
        total_after_discount: 0,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: '',
        amount_deposit: 0,
        amount_paid: 0,
        amount_due: 0,
        next_payment_date: '',
        fx_rate: 0,
        remark: '',
        product_detail: [],
        quotation_id: null,
        contract_id: null,
        reference_no: null,
        seller_id: null,
        credit_day: 0,
        payment_method_id: 1,
        bank_name: null,
        account_number: null,
        account_name: null,
      }
		}
	},
	async created() {
    this.loading = true
    await this.fetchResource()
    await this.find(this.$route.params.id)
      .then(() => this.setEditData())
      .finally(() => (this.loading = false))

  },
	computed: {
    ...mapState('wholesale/operation', ['customers', 'edit_data', 'employees']),
    employeeList(){
      return this.employees.map(el => ({
        value: el.employee_id,
        label: el.employee_name_en
      }))
    },
    customerList(){
      return this.customers.map(el => ({
        value: el.customer_id,
        label: el.customer_name
      }))
    }
  },
  methods: {
		...mapActions('wholesale/operation', ['fetchResource', 'update', 'find']),
		onUpdate() {
      this.waiting = true
      this.errors = new Errors()
      this.update({
        id: this.model.stock_out_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'wholesale' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData(){
			this.model.stock_out_id = this.edit_data.stock_out_id
      this.model.stock_out_date = this.edit_data.stock_out_date ? this.edit_data.stock_out_date : moment().format('DD-MM-YYYY')
      this.model.customer_id = this.edit_data.customer_id
      this.model.sub_total =  this.edit_data.sub_total
      this.model.discount = this.edit_data.discount
      this.model.total_after_discount = this.edit_data.total_after_discount
      this.model.vat_rate =  this.edit_data.vat_rate
      this.model.vat_amount = this.edit_data.vat_amount
      this.model.grand_total = this.edit_data.grand_total
      this.model.amount_deposit = this.edit_data.amount_deposit
      this.model.amount_paid =  this.edit_data.amount_paid
      this.model.amount_due = this.edit_data.amount_due
      this.model.next_payment_date = this.edit_data.next_payment_date
      this.model.fx_rate = this.edit_data.fx_rate
      this.model.remark = this.edit_data.remarks
      this.model.quotation_id = this.edit_data.quotation_id
      this.model.contract_id = this.edit_data.contract_id
      this.model.reference_no = this.edit_data.reference_no
      this.model.seller_id = this.edit_data.seller_id
      this.model.credit_day = this.edit_data.credit_day
      this.model.payment_method_id = this.edit_data.payment_method_id
      this.model.bank_name = this.edit_data.bank_name
      this.model.account_number = this.edit_data.account_number
      this.model.account_name = this.edit_data.account_name

      this.model.product_detail = []
      // clear product in state before push new product on change
      this.$store.commit('wholesale/operation/SET_PRODUCT', [])

      if(this.edit_data.customer) {
        this.$store.commit('wholesale/operation/PUSH_NEW_CUSTOMER', {
          customer_id: this.edit_data.customer_id,
          customer_name: this.edit_data.customer.customer_name
        })
      }

      if(this.edit_data.seller_id) {
        this.$store.commit('wholesale/operation/PUSH_EMPLOYEE', {
          employee_id: this.edit_data.seller_id,
          employee_name_en: this.edit_data.user.name
        })
      }

      this.edit_data.details.forEach(el => {
          // push product to stat be able to change uom to get new price
          this.$store.commit('wholesale/operation/SET_PRODUCT',{
            uom_cat_id: el.product.uom_cat_id,
            product_id: el.product_id,
            sale_code: el.sale_code,
            uom_category: el.product.uom_category
          })

          // push to model in detail list
          this.model.product_detail.push({
            product_id: el.product_id,
            product_name_en: el.product_name_en,
            barcode: el.barcode,
            uom_id: el.uom_id,
            quantity: el.quantity,
            unit_price: el.unit_price,
            discount_type: el.discount_type,
            discount_rate: el.discount_rate,
            discount_amount: el.discount_amount,
            total_after_discount: el.total_after_discount,
            vat_rate: el.vat_rate,
            vat_amount: el.vat_amount,
            grand_total: _.round( el.grand_total),
            promo_ref_promo_product_id: el.ref_promo_product_id,
            promo_type_id: el.promo_type_id,
            serial_list: el.serial_list,
            is_custom: el.is_custom,
            has_serial: el.is_generate_unique_serial
          })
      });
    },
		clearInput() {
      this.model.stock_out_date = moment().format('DD-MM-YYYY')
      this.model.customer_id = ''
      this.model.sub_total = ''
      this.model.discount = 0
      this.model.total_after_discount = 0
      this.model.vat_rate = 0
      this.model.vat_amount = 0
      this.model.grand_total = ''
      this.model.amount_deposit = 0
      this.model.amount_paid = 0
      this.model.amount_due = 0
      this.model.next_payment_date = ''
      this.model.fx_rate = 0
      this.model.remark = ''
      this.model.product_detail = []
      this.model.quotation_id = null
      this.model.contract_id = null
      this.model.reference_no = null
      this.model.seller_id = null
      this.model.credit_day = 0
      this.model.payment_method_id = 1
      this.model.bank_name = null
      this.model.account_number = null
      this.model.account_name = null
		},
    onCalculate() {
      this.$refs.itemDetail.calculate()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/stockIn/CLEAR_SETUP')
    this.$store.commit('stock/stockIn/SET_EDIT_DATA', {})
    next()
  }
}
</script> 